import { render, staticRenderFns } from "./VendorsTable.vue?vue&type=template&id=559f5782"
import script from "./VendorsTable.vue?vue&type=script&lang=js"
export * from "./VendorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports